EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.RotatePopUp = function() {
    EHDI.aka.Container.call(this);

    var sprite = new EHDI.aka.Sprite (EHDI.Assets.images["icon_rotate"]);
    sprite.anchor.set(0.5, 0.5);
    this.addChild(sprite);
    
    /*
    var rotateLabel = new EHDI.aka.PixiText(EHDI.localization.strings["rotate"].content, {fontSize : EHDI.localization.strings["rotate"].size, align : "center", fill : "#FFFFFF", fontFamily: 'nuevastd-bold', padding: EHDI.localization.strings["rotate"].size * 0.1});
    rotateLabel.anchor.set(0.5, 0.5);
    rotateLabel.position.set(0, EHDI.screen.stageHeight * 0.35);
    this.addChild(rotateLabel);
    //*/

    this.interactive = true;
    this.visible = (EHDI.screen.viewWidth < EHDI.screen.viewHeight);
};

EHDI.popup.RotatePopUp.prototype = Object.create(EHDI.aka.Container.prototype);